import type ArticleLocal from "~/libs/interfaces/ArticleLocal"

export const useArticleTools = (article?: ArticleLocal) => {

  const getPath = (route: string = 'articles-articleUrl') => {
    const localePath = useLocalePath()
    if (article?.path) {
      let path = article?.path
      if (path?.at(0) === '/') {
        path = path.slice(1, path.length)
      }
      if (path?.at(path?.length-1) === '/') {
        path = path.slice(0, path.length-1)
      }
      return localePath({name: route, params: {articleUrl: path}})
    } else if (article?.url) {
      return article?.url
    }
  }

  const getDetailPath = () => {
    return getPath('articles-articleUrl')
  }

  const getGalleryPath = () => {
    return getPath('galleries-articleUrl')
  }

    const getSearchResultPath = (query?: string) => {
        const localePath = useLocalePath()
        return localePath({ name: "search", query: { q: query} });
    }

    return {
        getDetailPath,
        getGalleryPath,
        getSearchResultPath,
    }
}